export const updatePrimaryServiceGroup = ({ serviceGroups, orgGroups, patch }) => {
    const selectedServiceGroup = serviceGroups[0] || {};
    const selectedOrgGroup = orgGroups[0] || {};

    const updatedServiceGroups = [...serviceGroups];
    updatedServiceGroups[0] = {
        ...selectedServiceGroup,
        ...patch,
        id: selectedOrgGroup?.id,
        name: selectedOrgGroup?.name,
    };

    return updatedServiceGroups;
};
